import { Service } from '../../../requests/caipirinha-api/interfaces/authorizarionTerm';
import { toBRL } from '../../../utils/money.util';

export const replaceParameters = (html: string, service: Service) => {
  const parametersKeys = Object.keys(service) as Array<keyof typeof service>;
  service.totalPrice = toBRL(Number(service.totalPrice));

  parametersKeys.forEach(param => {
    html = html.replaceAll(`{{${param}}}`, `<strong>${service[param]}</strong>`);
  });

  return html;
};
